module.exports = __webpack_public_path__ + "img/11.4ecad3f3.png";